import { defineComponent } from "vue";
import * as yup from "yup";
import { mapState } from "vuex";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Button from "@/components/general/Button";
import useInputs from "@/components/general/Inputs";
import Breadcrumb from "@/components/general/Breadcrumb";
import Steps from "@/components/legal/Steps";

// services
import processSevices from "@/services/legal/service.js";

const { Input, Select, Textarea, Date } = useInputs();
const string = yup
  .string()
  .nullable()
  .transform((curr, orig) => (orig === "" ? "" : curr));
const number = yup.number().nullable();
const object = yup
  .object()
  .shape({
    name: string,
    value: number | string,
  })
  .nullable();

const stepThreeProcessFormSchema = yup.object().shape({
  risk_type: object,
  management_option: object,
  actions: string,
  tracking: object,
});

const stepTwoProcessFormSchema = yup.object().shape({
  result: object.required("Campo requerido"),
  status: object.required("Campo requerido"),
  provision: object.required("Campo requerido"),
  guardianship_action: object.required("Campo requerido"),
  complain: object.required("Campo requerido"),
  evidence: object.required("Campo requerido"),
  prescription: object.required("Campo requerido"),
  lawyer: object.required("Campo requerido"),
  court: object.required("Campo requerido"),
  amount: number
    .typeError("age must be a number")
    .min(0, "Solo numeros positivos"),
});

const stepOneProcessFormSchema = yup.object().shape({
  control_type: object,
  position: object,
  description: string,
  objective: string,
  controlEvidence: string,
  procedure: string,
  periodicity: object,
  evaluation: object,
});

export default defineComponent({
  name: "Legal_process_edit",
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Button,
    Input,
    Select,
    Textarea,
    Date,
    Breadcrumb,
    Steps,
  },
  data() {
    return {
      breadcrumb: [
        { name: "Procesos", active: false, link: "/legal/process" },
        { name: "Editar proceso", active: true, link: "" },
      ],
      step: 0,
      title: [
        "Análisis de Controles",
        "Actualizar Información",
        "Gestión del Riesgo",
      ],
      listProgress: [
        { title: "Controles", icon: "controls" },
        { title: "Actualizar", icon: "update" },
        { title: "Riesgo", icon: "risk" },
      ],
      isEdit: false,
      errors: {},
      formData: {
        control_type: null,
        position: null,
        description: null,
        objective: null,
        controlEvidence: null,
        procedure: null,
        periodicity: null,
        evaluation: null,
        result: null,
        status: null,
        provision: null,
        guardianship_action: null,
        complain: null,
        evidence: null,
        prescription: null,
        lawyer: null,
        court: null,
        risk_type: null,
        management_option: null,
        actions: null,
        tracking: null,
        type: null,
        dateNotification: '',
        worker: null,
        cc: null,
        amount: null,
      },
      options: {
        control_type: [],
        positions: [],
        periodicity: [],
        evaluation: [],
        result: [],
        status: [],
        provision: [],
        guardianship_action: [],
        complain: [],
        evidence: [],
        prescription: [],
        lawyers: [],
        courts: [],
        risk_types: [],
        management_option: [],
        tracking: [],
        plaintiff_type: [],
        process_types: [],
      },
    };
  },
  methods: {
    goBack() {
      this.$router.push("/legal/process");
    },
    confirmCancel() {
      this.$bvModal.show("modal-confirm");
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    validate(field) {
      if (this.step === 0) {
        stepOneProcessFormSchema
          .validateAt(field, this.formData)
          .then(() => {
            this.computedErrors = field;
          })
          .catch((err) => {
            this.computedErrors = err;
          });
      } else if (this.step === 1) {
        stepTwoProcessFormSchema
          .validateAt(field, this.formData)
          .then(() => {
            this.computedErrors = field;
          })
          .catch((err) => {
            this.computedErrors = err;
          });
      } else {
        stepThreeProcessFormSchema
          .validateAt(field, this.formData)
          .then(() => {
            this.computedErrors = field;
          })
          .catch((err) => {
            this.computedErrors = err;
          });
      }
    },
    submitData() {
      console.log(this.formData)
      stepThreeProcessFormSchema
        .validate(this.formData)
        .then(() => {
          const formData = {
            risk_type_id: this.formData.risk_type?.id,
            court_id: this.formData.court?.id,
            guardianship_action: this.formData.guardianship_action?.id,
            complain: this.formData.complain?.id,
            result: this.formData.result?.id,
            evidence: this.formData.evidence?.id,
            prescription: this.formData.prescription?.id,
            provision: this.formData.provision?.id,
            plaintiff_type: this.formData.worker?.id,
            plaintiff_document: this.formData.cc,
            notification_date: this.formData.dateNotification,
            process_type_id: this.formData.type?.id,
            risk_management: {
                options: this.formData.management_option?.id,
                actions: this.formData.actions,
                tracking: this.formData.tracking?.id
            },
            status: this.formData.status?.id,
            lawyer_id: this.formData.lawyer?.id,
            control_analyses: {
                type: this.formData.control_type?.id,
                description: this.formData.description,
                position_id: this.formData.position?.id,
                objective: this.formData.objective,
                procedure: this.formData.procedure,
                evidence: this.formData.controlEvidence,
                periodicity: this.formData.periodicity?.id,
                evaluation: this.formData.evaluation?.id
            },
            amount: this.formData.amount
        };
          processSevices.updateProcess(this.$route.params.id,formData).then((response) => {
            if (!response.error) this.$bvModal.show("modal-message");
            else
              Object.values(response.error.detail).forEach((v) =>
                this.makeToast(v)
              );
          });
        })
        .catch((err) => {
          this.computedErrors = err;
        });
    },
    nextStep() {
     /*  if (this.step === 0) {
        stepOneProcessFormSchema
          .validate(this.formData)
          .then(() => {
            this.step++;
          })
          .catch((err) => {
            this.computedErrors = err;
          });
      } else if (this.step === 1) {
        stepTwoProcessFormSchema
          .validate(this.formData)
          .then(() => {
            this.step++;
          })
          .catch((err) => {
            this.computedErrors = err;
          });
      } */
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    initData() {
      processSevices.getOptions().then((response) => {
        this.options = response.data;
        processSevices.getProcess(this.$route.params.id).then((response) => {
          this.formData.lawyer = {id: response.data.lawyer.id, name: response.data.lawyer.name};
          this.formData.result = response.data.result;
          this.formData.status= response.data.status;
          this.formData.court= response.data.court;
          this.formData.provision= response.data.provision;
          this.formData.prescription = response.data.prescription;
          this.formData.guardianship_action= response.data.guardianship_action;
          this.formData.complain= response.data.complain;
          this.formData.evidence= response.data.evidence;
          this.formData.control_type = response.data.control_analysis?.type
          this.formData.position = response.data.control_analysis?.position
          this.formData.description = response.data.control_analysis?.description
          this.formData.objective = response.data.control_analysis?.objective
          this.formData.controlEvidence = response.data.control_analysis?.evidence
          this.formData.procedure = response.data.control_analysis?.procedure
          this.formData.periodicity = response.data.control_analysis?.periodicity
          this.formData.evaluation = response.data.control_analysis?.evaluation
          this.formData.risk_type = response.data.risk_type
          this.formData.management_option = response.data.risk_management?.options ?? null
          this.formData.actions = response.data.risk_management?.actions ?? null
          this.formData.tracking = response.data.risk_management?.tracking ?? null
          this.formData.type = response.data.process_type
          this.formData.dateNotification = response.data.notification_date
          this.formData.worker = response.data.plaintiff_type
          this.formData.cc = response.data.plaintiff_document
          this.formData.amount = response.data.amount
        })
      });
    },
    makeToast(msg) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Datos no guardados",
        autoHideDelay: 7000,
        appendToast: true,
        variant: "danger",
        solid: true,
        noCloseButton: true,
      });
    },
  },
  mounted() {
    this.initData();
    this.makeToast();
  },
  computed: {
    computedErrors: {
      get() {
        return this.errors;
      },
      set(newErr) {
        if (typeof newErr === "string") {
          delete this.errors[newErr];
        } else {
          if (newErr.path !== undefined) {
            const auxError = { [newErr.path]: newErr.message };
            this.errors = auxError;
          } else {
            console.error(newErr);
          }
        }
      },
    },
    ...mapState("modCore", ["user"]),
  },
});
